<template lang="pug">
  div.d-flex.align-items-center.left-line.ml-2.mr-2.pl-2(style="font-size: 16px;")
    | デザイン更新日時
    div.ml-2.mr-1(v-if="designList.length")
      select.form-control-sm.auto-submit-select(
        style="font-size: 15px;"
        @change="onDesignChange"
      )
        option(value="" disabled) 選択してください
        option(
          v-for="(design, index) in designList"
            :key="index"
            :value="design.id"
            :selected="design.id === designId"
        ) {{ formatDate(design.updated_at) }}
      button.btn.btn-sm.btn-danger.ml-2(v-if="designList.length > 1 && show_delete_btn  " @click="deleteSelectedDesign") 削除
    div.ml-2.mr-1(v-else)
      select.form-control-sm.auto-submit-select(style="font-size: 15px;")
        option(value="" selected) 選択してください

</template>
<script>
import heatmapApi from '../apis/heatmap';

export default {
  props: {
    designs: {
      type: Array,
      default: () => [],
    },
    design_id: {
      type: Number,
      default: 0,
    },
    state_name: {
      type: String,
      default: "heatmap"
    },
    show_delete_btn: {
      type: Boolean,
      default: false,
    },
    heatmap_id: {
      type: Number,
      required: true,
    },

  },
  data() {
    return {
      designList: [],
      designId: 0,
    }
  },
  methods: {
    async onDesignChange(event) {
      const selectedDesignId = event.target.value;
      if (selectedDesignId) {
        this.$store.commit( `${this.state_name}/setHeatmapDesignId`, selectedDesignId)
        const design = this.designList.find(d => d.id == selectedDesignId)
        if (design){
          if(this.$store.state[this.state_name].device == "pc"){
            this.$store.commit( `${this.state_name}/setPageHeight`, design.pc_height )
          } else {
            this.$store.commit( `${this.state_name}/setPageHeight`, design.sp_height )
          }
        }
        this.designId = selectedDesignId
      }
    },
    formatDate(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${d.getDate().toString().padStart(2, "0")} ${d
        .getHours()
        .toString()
        .padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
    },
        async deleteSelectedDesign() {
      if (!this.designId) {
        alert("削除するデザインを選択してください。");
        return;
      }
      if (!confirm("本当に削除しますか？")) return;
      try {
        const response = await heatmapApi.deleteDesign(
          {
            token: this.$store.state[this.state_name].token,
            design_id: this.designId,
          }
        );
        this.designList = response.data.heatmap_designs
        this.designId = response.data.new_design_id
        this.$store.commit( `${this.state_name}/setHeatmapDesignId`, this.designId)
      } catch (error) {
        console.error('Error delete heatmap design', error);
      }
    },

  },
  mounted() {
    this.designId = this.design_id
    this.designList = this.designs
  },
  components: {
  },
};
</script>
